import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, IsDateString } from "class-validator";

export class TaskEdit {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  type!: number | null;
  @IsString()
  @Expose()
  typeName!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  params!: string;
  @IsString()
  @Expose()
  officeShortName!: string;
  @IsDateString()
  @Expose()
  @IsOptional()
  nextRunAt!: string;
  @IsDateString()
  @Expose()
  @IsOptional()
  lastRunAt!: string;
  @IsBoolean()
  @Expose()
  inExecute!: boolean;
  @IsBoolean()
  @Expose()
  processed!: boolean;
  @IsBoolean()
  @Expose()
  enabled!: boolean;
  @IsBoolean()
  @Expose()
  isNextExecutionTimeConstant!: boolean;
  @IsBoolean()
  @Expose()
  isExecuteInTask!: boolean;
  @IsNumber()
  @Expose()
  unsuccessfulTryStartCounter!: number | null;

  constructor() {
    this.type = null;
    this.typeName = "";
    this.params = "";
    this.nextRunAt = "";
    this.lastRunAt = "";
    this.unsuccessfulTryStartCounter = null;
    this.inExecute = false;
    this.processed = false;
    this.enabled = false;
    this.isExecuteInTask = false;
    this.isNextExecutionTimeConstant = false;
  }
}
